import React from "react";
import {Box, CircularProgress, Typography} from "@mui/material";
import {useTheme} from "../../../contexts/theme";

interface SpinnerBoxProps{
    height: string;
    text?: string;
    spinnerSize?: number;
    textColor?: string;
}

const SpinnerBox: React.FC<SpinnerBoxProps> = ({height, text, spinnerSize = 40, textColor}) => {
    const theme = useTheme();

    return(<Box display={'flex'} height={height} flexDirection={'column'} justifyContent={'center'} width={'100%'}>
        <Box display={'flex'} justifyContent={'center'} width={'100%'}>
            <Box display={'flex'} flexDirection={'column'} width={'50%'}>
                <Box sx={{marginBottom: theme.spacing.md}} width={'100%'} display={'flex'} justifyContent={'center'}>
                    <CircularProgress size={spinnerSize} sx={{color: theme.palette.orange}}/>
                </Box>
                {text && <Typography textAlign={'center'} sx={{color: textColor ? textColor : theme.palette.white}} >{text}</Typography>}
            </Box>
        </Box>
    </Box>)
}

export default SpinnerBox;